import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import { db } from "../firebase";
import { makePaymentPending } from "./services";

const Button = ({ children, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-max max-w-full hover:bg-darkblue  bg-blue text-white py-2 px-8 text-lg"
    >
      {children}
    </button>
  );
};

const PAYHERE = ({ uid }) => {
  const [currentItem, setCurrentItem] = useState(null);
  const [loading, setLoading] = useState(null);
  const [ordering, setOrdering] = useState(null);
  const params = useParams();
  const history = useHistory();
  useEffect(() => {
    setLoading(true);
    db.collection("websites")
      .doc(params.id)
      .get()
      .then((doc) => {
        setLoading(false);
        setCurrentItem(doc.data());
      })
      .catch((err) => {
        alert(
          "Something happened while fetching data. If this happens continuesly please contact us. Redirecting..."
        );
        history.push("/sign-in");
        setLoading(false);
      });
  }, [params.id]);

  return (
    <div className="flex flex-col w-full overflow-y-auto h-full py-12">
      {currentItem && (
        <div className="flex flex-col w-full">
          {!currentItem.sold && !currentItem.pending && (
            <div className="text-lg mb-8 w-full">
              Are you ready to buy {currentItem.title}?
            </div>
          )}
          {!currentItem.sold && !currentItem.pending && (
            <div className="flex items-center flex-wrap w-full gap-8">
              <Button
                onClick={() => {
                  setOrdering(true);
                  db.collection("websites")
                    .doc(params.id)
                    .update({
                      payment_pending: true,
                    })
                    .then(() => {
                      db.collection("pending_orders").doc(uid+params.id).set({
                        user: uid,
                        website: params.id,
                        title:currentItem.title,
                        price:currentItem.price,
                        id:uid+params.id
                      });
                      setOrdering(false);
                      alert(
                        "Order made successfully. We will contact you soon."
                      );
                      history.push('/')
                    })
                    .catch((err) => {
                      console.log(err);
                      setOrdering(false);
                      alert(
                        "Something happened while making order. If this happens continuesly please contact us. Redirecting..."
                      );
                    });
                }}
              >
                Yes, Settle Order
              </Button>
              <Link
                to={`/web/${currentItem.id}`}
                className="text-lg text-blue "
              >
                No I want to know more
              </Link>
            </div>
          )}
          {currentItem.sold && !currentItem.pending && (
            <div className="text-red text-lg">
              This website already sold out.
            </div>
          )}
          {currentItem.pending && (
            <div className="text-gray text-lg">
              Currently a payment is pending on this website.
            </div>
          )}
        </div>
      )}
      {loading && <p className="text-base w-full italic mt-4">Loading...</p>}
      {ordering && <p className="text-base w-full italic mt-4">Settling order..</p>}
    </div>
  );
};

export default PAYHERE;
